<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <h4 class="text-light"><i class="fa fa-user"></i> <span id="username-placeholder">{{username}}</span></h4>
    </template>
    <template slot="dropdown">
      <b-dropdown-header v-show="show_language_select" tag="div" class="text-center"><strong>{{$t('language')}}:&nbsp;&nbsp;{{$t('name')}}</strong></b-dropdown-header>
      <b-dropdown-item v-show="show_language_select" @click="language_set('zh_TW')">中文(繁體)</b-dropdown-item>
      <b-dropdown-item v-show="show_language_select" @click="language_set('en')">English</b-dropdown-item>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>{{$t('default_header_dropdown.title')}}</strong></b-dropdown-header>
      <b-dropdown-item v-show="show_qrcode_scanner_btn" @click="emit_scan_qrcode"><i class="fa fa-qrcode" />{{$t('qrcode_scanning')}}</b-dropdown-item>
      <b-dropdown-item v-show="show_settings_btn" @click="goto_members_setting"><i class="fa fa-users" />{{$t('default_header_dropdown.settings')}}</b-dropdown-item>
      <b-dropdown-item @click="logout"><i class="fa fa-lock" />{{$t('default_header_dropdown.logout')}}</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>

import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import config from '@/config/global'
import notifications from '@/config/notifications'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import jQuery from 'jquery'

const eventbus = config.eventbus;

export default {
  name: 'DefaultHeaderDropdown',
  notifications,
  components: {
    AppHeaderDropdown
  },
  data() {
    return {
      username: 'iTaiwan',
      show_qrcode_scanner_btn: true,
      show_settings_btn: false,
      show_language_select: false,
    };
  },
  mounted(){

    let user_key = this.$route.path.indexOf('/dashboard/showdevice') !== -1 || this.$route.path.indexOf('/dashboard/history') !== -1  || this.$route.path.indexOf('/dashboard/transactions') !== -1 || this.$route.path.indexOf('/dashboard/members-setting') !== -1 || this.$route.path.indexOf('/dashboard/maps') !== -1 || this.$route.path.indexOf('/search/devices') !== -1 || this.$route.path.indexOf('/yushan') !== -1 ? 'user' : 'adminuser';

    let user  = this.$state.$get(user_key);

    this.show_qrcode_scanner_btn = user_key === 'adminuser' ? false : true;
    this.show_settings_btn = user_key === 'adminuser' ? false : true;

    if(user_key === 'user') {
      this.show_language_select = true;
      let language = this.$state.$get('language');
      if(language && language != this.$i18n.locale) {
        this.$i18n.locale = language;
        this.$state.$set('language', language);
      }
    }
    
    //console.info('user:', user.username);
    if(user){
      this.username = user.username;
    }
  },
  methods: {
    logout(){

      let user_key = this.$route.path.indexOf('/dashboard/showdevice') !== -1 || this.$route.path.indexOf('/dashboard/history') !== -1 || this.$route.path.indexOf('/dashboard/transactions') !== -1 || this.$route.path.indexOf('/dashboard/members-setting') !== -1 || this.$route.path.indexOf('/dashboard/maps') !== -1 || this.$route.path.indexOf('/search/devices') !== -1 || this.$route.path.indexOf('/yushan') !== -1  ? 'user' : 'adminuser';

      let user_token = this.$state.$get(user_key);

      if(user_token){
        this.$state.$del(user_key);
      }

      if(this.$state.$get('adminuser')){
        this.$state.$del('adminuser'); 
      }

      if(this.$state.$get('uuid')){
        this.$state.$del('uuid'); 
      }

      if(this.$state.$get('keyword')){
        this.$state.$del('keyword'); 
      }

      if(this.$state.$get('ccff')){
        this.$state.$del('ccff'); 
      }

      if(this.$state.$get('device_id')){
        this.$state.$del('device_id'); 
      }

      let target = user_key === 'adminuser' ? '/_admin_' : '/';
      let ccid   = this.$state.$get('ccid');
      let href   = location.origin + `/#${target}`;

      if(this.$state.$get('ccid')){
        this.$state.$del('ccid'); 
      }

      if(ccid){
        href += '?' + jQuery.param({
          ccid
        });
      }

      // this.$router.push(target);
      window.location = href;
      // location.reload();

      this.showInfo({message: this.$t('default_header_dropdown.goodbye')});

    },//eo logout

    emit_scan_qrcode(){
      eventbus.$emit('start-qrcode-scanning');
    },

    goto_members_setting(){
      let href = location.origin + '/#/dashboard/members-setting';
      window.location = href;
      //location.reload();
    },

    language_set(set_language){
      if(set_language != this.$i18n.locale) {
        this.$i18n.locale = set_language;
        this.$state.$set('language', set_language);
      } 
    },
  }
}
</script>